import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Key, Users, Sparkles, Shirt, ShieldCheck, Phone, Globe, LucideIcon, ChevronDown } from 'lucide-react';

interface ServiceItem {
    titleKey: string;
    descKey: string;
    icon: LucideIcon;
}

const serviceItems: ServiceItem[] = [
    { titleKey: 'servicesList.keyHolding',         descKey: 'servicesList.keyHoldingDesc',         icon: Key },
    { titleKey: 'servicesList.propertyManagement', descKey: 'servicesList.propertyManagementDesc', icon: Home },
    { titleKey: 'servicesList.meetAndGreet',       descKey: 'servicesList.meetAndGreetDesc',       icon: Users },
    { titleKey: 'servicesList.cleaningService',    descKey: 'servicesList.cleaningServiceDesc',    icon: Sparkles },
    { titleKey: 'servicesList.laundryService',     descKey: 'servicesList.laundryServiceDesc',     icon: Shirt },
    { titleKey: 'servicesList.support247',         descKey: 'servicesList.support247Desc',         icon: Phone },
    { titleKey: 'servicesList.mortgage',           descKey: 'servicesList.mortgageDesc',           icon: ShieldCheck },
    { titleKey: 'servicesList.webDevelopment',     descKey: 'servicesList.webDevelopmentDesc',     icon: Globe },
];

const ServicesList = () => {
    const { t } = useTranslation();
    const [showAll, setShowAll] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isExpanding, setIsExpanding] = useState(false);

    // Detect mobile screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleShowMore = () => {
        setIsExpanding(true);
        setTimeout(() => {
            setShowAll(true);
        }, 300);
    };

    const visibleServices = isMobile && !showAll ? serviceItems.slice(0, 4) : serviceItems;

    return (
        <div className="services-list">
            <div className="services-grid">
                {visibleServices.map((item, i) => {
                    const Icon = item.icon;
                    const featured = i < 2;
                    return (
                        <article className={`service-card${featured ? ' service-card-featured' : ''}`} key={i}>
                            <div className="service-card-icon">
                                <Icon size={featured ? 32 : 28} color="#d89d37" strokeWidth={1.8} />
                            </div>
                            <h3 className="h3-title service-card-title">{t(item.titleKey)}</h3>
                            <p className="service-card-desc">{t(item.descKey)}</p>
                        </article>
                    );
                })}
            </div>

            {isMobile && !showAll && (
                <div
                    className={`show-more-btn-wrapper ${isExpanding ? 'hiding' : ''}`}
                    style={{ textAlign: 'center', marginTop: '30px', marginBottom: '20px' }}
                >
                    <button
                        onClick={handleShowMore}
                        className="sec-btn"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        <span>Show More</span>
                        <ChevronDown size={18} />
                    </button>
                </div>
            )}

            <div className="services-list-cta">
                <Link to="/services" className="sec-btn services-cta-btn"><span>{t('servicesList.exploreAllServices')}</span></Link>
            </div>
        </div>
    );
};

export default ServicesList;